import { useEffect, useState } from "react";
import api from "../../../../utils/api";
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    OutlinedInput,
} from "@mui/material";

const initialForm = {
    name: "",
    code: "",
    is_active: true,
};

export default function LessonTypeModal({ open, onClose, row = null }) {
    const [form, setForm] = useState(initialForm);
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (row) {
            setForm({
                name: row.name || "",
                code: row.code || "",
                is_active: Boolean(row.is_active),
            });
        } else {
            setForm(initialForm);
        }
        setSaving(false);
        setErrors({});
    }, [row, open]);

    const handleSubmit = async () => {
        setSaving(true);
        setErrors({});
        try {
            const payload = {
                name: String(form.name || "").trim(),
                code: String(form.code || "").trim() || null,
                is_active: Boolean(form.is_active),
            };
            if (row?.id) {
                await api.put(`admin/lesson-types/${row.id}`, payload);
            } else {
                await api.post("admin/lesson-types", payload);
            }
            onClose(true);
        } catch (e) {
            if (e.errors) setErrors(e.errors);
            else if (e.response?.data?.errors) setErrors(e.response.data.errors);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{row ? "Edit lesson type" : "Create lesson type"}</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <FormControl error={!!errors.name?.[0]}>
                        <FormLabel htmlFor="lesson-type-name">Name</FormLabel>
                        <OutlinedInput
                            id="lesson-type-name"
                            value={form.name}
                            onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                        />
                        {errors.name && <FormHelperText>{errors.name[0]}</FormHelperText>}
                    </FormControl>
                    <FormControl error={!!errors.code?.[0]}>
                        <FormLabel htmlFor="lesson-type-code">Code (optional)</FormLabel>
                        <OutlinedInput
                            id="lesson-type-code"
                            value={form.code}
                            onChange={(e) => setForm((p) => ({ ...p, code: e.target.value }))}
                        />
                        {errors.code && <FormHelperText>{errors.code[0]}</FormHelperText>}
                    </FormControl>
                    <FormControl>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={Boolean(form.is_active)}
                                    onChange={(e) => setForm((p) => ({ ...p, is_active: e.target.checked }))}
                                />
                            )}
                            label="Active"
                        />
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} disabled={saving}>Cancel</Button>
                <Button variant="contained" sx={{ color: "#fff" }} onClick={handleSubmit} disabled={saving}>
                    {saving ? <CircularProgress size={24} color="inherit" /> : (row ? "Save" : "Create")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
